<template>
    <div>
        <form action="">
                <div class="modal-card takes-75">
                    <header class="modal-card-head">
                        <p class="modal-card-title has-text-white">Add Misc Part</p>
                        <button
                            type="button"
                            class="delete"
                            @click="$emit('close')"/>
                    </header>
                    <section class="modal-card-body has-background-dvodark">
                            <b-autocomplete
                                v-model="warrantyObj.service_code"
                                placeholder="Enter the Service Code"
                                :open-on-focus="true"
                                :data="serviceCodes"
                                field="code"
                                :clearable="false"
                            >
                                <template v-slot="props">
                                    <strong>{{props.option.code}}</strong>: {{props.option.description}}
                                </template>
                            </b-autocomplete>                        
                        <div v-for="(part, index) in warrantyObj.parts" :key="part.length">
                            <b-field label="Part Used/Quantity" grouped>
                                <b-autocomplete
                                    v-model="inputArray[index]"
                                    :data="filteredDataObj(index)"
                                    field="number"
                                    :clearable="false"
                                    @select="data => { updateWarrantyObj(data, index) }"
                                    >
                                    <template v-slot="props">
                                        {{props.option.number}}
                                    </template>
                                </b-autocomplete>                             
                                <b-numberinput controls-position="compact" :min="1" v-model="warrantyObj.parts[index].quantity" required></b-numberinput>
                                <b-button class="is-danger" @click="removePartField(index)"><i class="fas fa-minus-circle"></i></b-button>
                            </b-field>
                        </div>
                        <b-button class="mt-2 is-dvogreen" @click="addPartField()"><i class="fas fa-plus-circle"></i> Add Part</b-button>
                    </section>
                    <footer class="modal-card-foot">
                        <b-button class="is-dvogreen" @click="$emit('pass-warranty-obj', warrantyObj); $emit('close');">Finish Request</b-button>
                    </footer>
                </div>
        </form>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { getParts, getServices } from '../graphql/queries'
export default {
    data(){
        return {
            warrantyObj: {
            warranty_id: null,
            service_code: null,
            parts: []
            },
            parts: [],
            partInputs: [],
            serviceCodes: [],
            inputArray: [""]
        }
    },
    computed:{

    },
    methods:{
        filteredDataObj(i) {
            return this.parts.filter(option => {
                if(option === null || option === undefined){
                    return option
                } else {
                    console.log(option.number)
                    console.log(this.inputArray[i])
                    return (
                        option.number
                            .toString()
                            .toLowerCase()
                            .indexOf(this.inputArray[i].toString().toLowerCase()) >= 0
                    )
                }
            })
        },
        async getParts(){
            const Parts = await API.graphql({
                query: getParts,
            });
            this.parts = Parts.data.getParts
        },
        handleInput (index){
            this.warrantyObj.parts[index].quantity = 1
        },
        updateWarrantyObj(partData, index){
            partData.quantity = 1
            this.warrantyObj.parts[index] = partData
        },
        addPartField(){
            this.inputArray.push("")
            this.warrantyObj.parts.push(
            {
                number: "",
                quantity: 0
            });

        },
        removePartField(index){
            this.warrantyObj.parts.splice(index, 1)
            this.inputArray.splice(index, 1)

        },
        async getServiceCodes(){
            const Services = await API.graphql({
                query: getServices,
            });
            
            this.serviceCodes = Services.data.getServices
        },
    },
    created(){
        this.getServiceCodes()
        this.getParts()
    }
}
</script>

<style lang="scss">
.takes-75{
    min-height: 75vh;
}
</style>